<!-- ================管理端-教研赛事详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">教研赛事详情</div>
        </div>
        <div class="create-content-container">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛名称：</span>
                        {{ form.raceName }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛范围：</span>
                        <span v-if="form.raceNature == 1">普通</span>
                        <span v-if="form.raceNature == 2">名师工作室</span>
                        <span v-if="form.raceNature == 3">名校长工作室</span>
                        <span v-if="form.raceNature == 4">群组</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.groupName">
                        <span class="item-span">工作室/群组：</span>
                        {{ form.groupName }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceNature == 1">
                        <span class="item-span">学段·年级·学科：</span>
                        {{ form.periodName || '--' }}•{{ form.gradeName || '--' }}•{{ form.subjectName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛方向：</span>
                        {{ form.raceDirectionName || form.raceDirection }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛级别：</span>
                        {{ form.raceLevelName }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">主办单位：</span>
                        {{ form.hostOrgName || form.orgTxt || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">联系方式：</span>
                        {{ form.contactInfo || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛负责人：</span>
                        {{ form.raceLeaderName || (form.leadUserList && form.leadUserList.map(e => e.trueName).join(',')) || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">报名阶段：</span>
                        {{ timestampToTime(form.beginTime) }} 至 {{ timestampToTime(form.endTime) }}
                    </div>

                    <div class="event-info-item-auto">
                        <span class="item-span">审核模式：</span>
                        {{ form.checkModeName || '--' }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.csCheckUserList && form.csCheckUserList.length > 0">
                        <span class="item-span">初审审核人：</span>
                        {{ form.csCheckUserList.map(e => e.trueName).join('、') }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.csBeginTime && form.csEndTime">
                        <span class="item-span">初审阶段：</span>
                        {{ timestampToTime(form.csBeginTime) }} 至 {{ timestampToTime(form.csEndTime) }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.fsCheckUserList && form.fsCheckUserList.length > 0">
                        <span class="item-span">复审审核人：</span>
                        {{ form.fsCheckUserList.map(e => e.trueName).join('、') }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.fsBeginTime && form.fsEndTime">
                        <span class="item-span">复审阶段：</span>
                        {{ timestampToTime(form.fsBeginTime) }} 至 {{ timestampToTime(form.fsEndTime) }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.zsCheckUserList && form.zsCheckUserList.length > 0">
                        <span class="item-span">终审审核人：</span>
                        {{ form.zsCheckUserList.map(e => e.trueName).join('、') }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.zsBeginTime && form.zsEndTime">
                        <span class="item-span">终审阶段：</span>
                        {{ timestampToTime(form.zsBeginTime) }} 至 {{ timestampToTime(form.zsEndTime) }}
                    </div>

                    <div class="event-info-item-auto" v-if="form.raceType == 0">
                        <span class="item-span">竞赛介绍：</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceType == 0" style="white-space: pre-wrap;margin-left: 10px">
                        {{ form.raceOverview }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceType == 0">
                        <span class="item-span">报名要求：</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceType == 0" style="white-space: pre-wrap;margin-left: 10px">
                        {{ form.raceRule }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceType == 1">
                        <span class="item-span">详情图片：</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.raceType == 1">
                        <div class="race-img-cover">
                            <img class="img-100" :src="form.imgUrl" alt="">
                        </div>
                    </div>

                    <div class="event-info-item-auto" v-if="form.isEva == 1">
                        <span class="item-span">评比权重：</span>
                        {{ form.evaWeight }}%
                    </div>
                    <div class="event-info-item-auto" v-if="form.isEva == 1">
                        <span class="item-span">评比时间：</span>
                        {{ timestampToTime(form.evaBeginTime) }} 至 {{ timestampToTime(form.evaEndTime) }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.isEva == 1">
                        <span class="item-span">评比地址：</span>
                        {{ form.evaAddress }}
                    </div>

                    <div class="info-column-container mt15">
                        <div class="column-title">附件资料</div>
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">上传附件：</span>
                    </div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item.fileId">
                                <div class="b-file-title" @click="downloadFile(item)">{{ item.fileName }}</div>
                                <div class="b-file-view" title="预览">
                                    <el-image @click="handleFileStatus(item.status)" class="b-file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl, item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载" @click="downloadFile(item)">
                                    <img class="b-file-icon" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length === 0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/image/data_empty.png" alt="" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">竞赛封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100" :src="form.raceCover" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { raceInfo } from "@/api/admin/race";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";

export default {
    components: {},
    name: "raceDetail",
    data() {
        return {
            timestampToTime,
            loading: true,
            raceId: '',
            fileList: [],
            form: {
                raceNature: '',
                raceName: '',
                raceLevel: '',
                raceType: 0,
                raceOverview: '',
                raceRule: '',
                raceCover: '',
                imgUrl: '',
                beginTime: '',
                endTime: '',
                contactInfo: '',
                isEva: 0,
                evaWeight: '',
                evaBeginTime: '',
                evaEndTime: '',
                evaAddress: '',
                scaleIds: '',
                zsScaleIds: '',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.raceId) {
            this.raceId = this.$route.query.raceId
            this.queryRaceInfo()
        }
    },
    mounted() {},
    methods: {
        backList() {
            this.$router.push({
                path: "/race",
            });
        },
        queryRaceInfo() {
            raceInfo({ raceId: this.raceId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    this.fileList = this.form.fileList || [];
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFileStatus(status) {
            if (status === 1) {
            } else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
    },
}
</script>
<style scoped>
.info-column-container {
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #377f7f;
    margin-bottom: 10px;
}
.column-title {
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.mt15 {
    margin-top: 15px;
}
.event-base-info-container {
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-part1-l {
    width: calc(100% - 300px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.event-info-item-auto {
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-part1-r {
    width: 300px;
    height: 100%;
}
.event-base-info-cover {
    width: 270px;
    height: 152px;
    box-sizing: border-box;
}
.event-base-info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.race-img-cover {
    width: 270px;
    height: 152px;
    margin-left: 10px;
}
.race-img-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.item-span {
    font-weight: bold;
    color: #377f7f;
    white-space: nowrap;
}
.b-file-info-container {
    width: 100%;
    height: auto;
}
.b-file-list {
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item {
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
}
.b-file-item:hover {
    color: #377f7f !important;
    font-weight: bold;
}
.b-file-title {
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 20px;
    box-sizing: border-box;
}
.b-file-view {
    width: 30px;
    height: 100%;
}
.b-file-download {
    width: 30px;
    height: 100%;
}
.b-file-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.data-empty {
    width: 100px;
    height: 100px;
    margin: auto;
}
.empty-icon {
    width: 100px;
    height: 40px;
}
.empty-icon img {
    width: 40px;
    height: 40px;
    margin-left: 30px;
}
.empty-title {
    width: 100px;
    font-size: 12px;
    text-align: center;
    color: #999999;
}
.img-100 {
    width: 100%;
    height: 100%;
}
@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
    .event-base-info-cover { width: 240px; height: 135px; }
    .b-file-list { width: 100%; }
}
</style>
